module.exports = __webpack_public_path__ + "img/close.a820f426.svg";